import React from 'react';
import OpenDNSBanner from '../../../components/OpenDNSBanner';
import { AnimatedTextInput, AnimatedPasswordInput, AnimatedSelect, AnimatedButton, HeroImageBanner } from '@opendns/opendns-dpl';
import Store from '../store';
import utils from '../../../utils';
import { browserHistory } from 'react-router';

class MainForm extends React.Component {

    constructor(props) {
        super(props);

        utils.getCountries((data) => {
            Store.dispatch({type: 'UPDATE', data: {countries: data} });
        });

        this.state = {
            countries: this.convertCountries(Store.getState().countries),
            errors: {
                empty: {
                    email: 'Email Address is required',
                    emailConfirm: 'Matching Email Address is required',
                    password: 'Password is required',
                    passwordConfirm: 'Matching password is required',
                    countryId: 'Country is required',
                },
                invalid: {
                    email: 'Email Address is invalid',
                    emailConfirm: 'Matching Email Address is invalid',
                    password: 'Password is invalid',
                    passwordConfirm: 'Matching password is invalid',
                    countryId: 'Country is required',
                    russia: 'This product, service, or free trial is not available for consumer use in Russia.',
                }
            },
            alertMessage: ''
        };
    }

    convertCountries(countries) {
        let returnVal = [];
        for(let code in countries) {
            returnVal.push({
                label: countries[code],
                value: code
            });
        }
        return returnVal;
    }

    checkTA15(callback) {
        // TODO uncomment when TA15 works
        // utils.callApi(
        //     { testing_uri: window.location.pathname },
        //     'internals/1/ta15',
        //     (data) => {
        //         if (data.response === 'M') {
        //             browserHistory.push('/premiumdns/error/hold');
        //         } else if (data.response === 'C') {
        //             browserHistory.push('/premiumdns/error/country');
        //         } else if (data.response === 'N') {
        //             callback();
        //             //browserHistory.push('https://www.opendns.com/setupguide');
        //         } else {
        //             browserHistory.push('/premiumdns/error/system');
        //         }
        //     },
        //     (data) => {
        //         browserHistory.push('/premiumdns/error/system');
        //     },
        //     'PUT'
        // );

        // we're having troubles with TA15 now so we'll skip testing it
        callback.call(this);
    }

    componentDidMount() {
        Store.subscribe(() => {
            this.setState({countries: this.convertCountries(Store.getState().countries)});
        });

        $('#password')
        .focus(this.showPasswordCriteria.bind(this))
        .blur(this.showPasswordCriteria.bind(this));
    }

    validatePasswords() {
        if (this.refs.passwordConfirm.state.value !== this.refs.password.state.value) {
            this.refs.passwordConfirm.setState({
                validationMessage: 'Passwords must match',
                isAlerting: true
            });
            return false;
        }
        return true;
    }

    validateEmails() {
        if (this.refs.emailConfirm.state.value !== this.refs.email.state.value) {
            this.refs.emailConfirm.setState({
                validationMessage: this.state.errors.invalid.emailConfirm,
                isAlerting: true
            });
            return false;
        }
        return true;
    }

    validateRussia() {
        if(this.refs.countryId.state.value == "RU")
        {
            this.refs.countryId.setState({
                validationMessage: this.state.errors.invalid.russia,
                isAlerting: true
            });
            return false;
        }
        return true;
    }

    handleForm(e) {
        e.preventDefault();
    }

    handleSubmit() {
        let data = {};
        let proceedFlag = true;

        this.setState({
            alertMessage: ''
        });

        for (var ref in this.refs) {
            if( this.refs.hasOwnProperty( ref ) ) {
                let field = this.refs[ref];
                data[field.props.name] = field.state.value;

                if (!field.state.isValid && field.props.isRequired) {
                    field.setState({
                        validationMessage: this.state.errors.invalid[field.props.name],
                        isAlerting: true
                    });
                    proceedFlag = false;
                }
                if (!field.state.value && field.props.isRequired) {
                    field.setState({
                        validationMessage: this.state.errors.empty[field.props.name],
                        isAlerting: true
                    });
                    proceedFlag = false;
                }
            }
        }

        proceedFlag = this.validateRussia() && this.validateEmails() && this.validatePasswords() && proceedFlag;

        if (proceedFlag) {
            Store.dispatch({type: 'UPDATE', data: { submitData: data } });
            this.checkTA15(this.postForm);
        }
    }

    postForm() {
        let submitData = Store.getState().submitData;

        $.ajax({
            url: '/homefree/submit',
            type: 'POST',
            data: JSON.stringify(submitData),
            contentType: 'application/json',
            success: this.doneCallback,
            error: this.failCallback.bind(this)
        });
    }

    doneCallback(data, textStatus, jqXHR) {
        window.location = 'https://www.opendns.com/setupguide/?url=homefree';
    }

    failCallback(jqXHR, textStatus, errorThrown) {
        if (jqXHR.status === 400) {
            if (jqXHR.responseJSON.hasOwnProperty('message')) {
                this.setState({
                    alertMessage: jqXHR.responseJSON.message
                });
            } else {
                browserHistory.push('/homefree/error/');
            }
        } else {
            browserHistory.push('/homefree/error/');
        }
    }

    showPasswordCriteria() {
        this.setState({revealCriteria: !this.state.revealCriteria});
    }

    showAlertMessage() {
        if (this.state.alertMessage !== '') {
            return (
                <div className="alert-message">
                    <p>{this.state.alertMessage}</p>
                </div>
            );
        }
        return '';
    }

    render() {

        if (this.state.revealCriteria) {
            var hints = <p>The password must contain at least one number, one lowercase letter, one capital letter, and one special character (!, @, #)</p>;
        }

        return (
            <div className="mainform-container">

                <section className="cisco-banner">
                    <div className="cisco-banner__logo">
                        <a href="http://www.cisco.com/" target="_blank">
                            <img src="https://d15ni2z53ptwz9.cloudfront.net/opendns-www/img/Cisco_Logo_RGB_Screen_White.png" className="cisco-banner__logo__img cisco-banner__logo__img--light" alt="OpenDNS is now a part of Cisco" title="OpenDNS is now a part of Cisco" />
                            <img src="https://d15ni2z53ptwz9.cloudfront.net/opendns-www/img/cisco-dark-logo.png" className="cisco-banner__logo__img cisco-banner__logo__img--dark" alt="OpenDNS is now a part of Cisco" title="OpenDNS is now a part of Cisco" />
                        </a>
                    </div>
                    <div className="cisco-banner__learn">
                        <p>
                            <span>OpenDNS is now part of Cisco</span>
                            <a href="http://www.cisco.com/web/about/ac49/ac0/ac1/ac259/opendns.html" target="_blank" className="cisco-banner__learnLink">
                                <span>Learn More </span>
                                <i className="fa fa-caret-right"></i>
                            </a>
                        </p>
                    </div>
                    <div className="cisco-banner__about">
                        <a href="http://www.cisco.com/web/about/index.html" target="_blank">About Cisco</a>
                    </div>
                </section>

                <OpenDNSBanner />

                <HeroImageBanner
                    size="small"
                    imageUrl="/images/Premium-DNS-Hero-Full-Page.png"
                >
                    <h1 className="hero-banner__heading">OpenDNS Home</h1>
                </HeroImageBanner>

                <div className="grid">
                    <div className="main-column">
                        <h2>You&apos;re just three steps away from a safer, faster, smarter and more reliable Internet — for free!</h2>

                        <div className="included-list condensed">
                            <h3>Benefits of OpenDNS Home</h3>
                            <ul>
                                <li><div className="check"></div><p>Websites will load faster, and with OpenDNS' 100% up-time, you won't have to worry about unreachable websites and DNS outages from your ISP.</p></li>
                                <li><div className="check"></div><p>With over 50 customizable filtering categories, OpenDNS Web content filtering keeps parents in control of what websites children visit at home.</p></li>
                                <li><div className="check"></div><p>OpenDNS blocks phishing websites that try to steal your identity and login information by pretending to be a legitimate website. Surf the Web with confidence.</p></li>
                            </ul>
                        </div>

                        <div className="business">
                            <img src="/images/Enterprise-Icon-Full-Page.png" alt="Business Icon" className="business__icon" />
                            <p className="business__threat">Looking for threat protection?</p>
                            <p><a href="https://umbrella.cisco.com" className="ext-link" data-type="Cisco Umbrella" target="_parent">Learn more about Cisco Umbrella <i className="fa fa-chevron-right"></i></a></p>
                        </div>
                    </div>
                    <div className="sidebar">
                        <p className="field-intro"><span className="account-check">Already have an account? <a href="https://login.opendns.com/">Sign in.</a></span><span className="req-fields-right">All fields are required.</span></p>

                        {this.showAlertMessage()}

                        <div>
                            <form noValidate id="homefree-signup" action="/homefree/submit" method="POST" onSubmit={this.handleForm.bind(this)}>
                                <AnimatedTextInput
                                    ref="email"
                                    name="email"
                                    label="Email address"
                                    isRequired={true}
                                    regex="^[A-Za-z0-9\.\-_\+]+@[A-Za-z0-9\.\-_]+\.[A-Za-z]+$"
                                />
                                <AnimatedTextInput
                                    ref="emailConfirm"
                                    name="emailConfirm"
                                    label="Confirm email address"
                                    isRequired={true}
                                    regex="^[A-Za-z0-9\.\-_\+]+@[A-Za-z0-9\.\-_]+\.[A-Za-z]+$"
                                />
                                <AnimatedSelect
                                    ref="countryId"
                                    name="countryId"
                                    label="Select your country"
                                    options={this.state.countries}
                                    isRequired={true}
                                    disableSearch={false}
                                />
                                <AnimatedPasswordInput
                                    ref="password"
                                    name="password"
                                    label="Create password"
                                    isRequired={true}
                                />
                                <AnimatedPasswordInput
                                    ref="passwordConfirm"
                                    name="passwordConfirm"
                                    label="Confirm password"
                                    isRequired={true}
                                    extendedMessage=""
                                />
                                <AnimatedButton
                                    isSubmit={true}
                                    isFullWidth={true}
                                    onClick={this.handleSubmit.bind(this)}>
                                        Get A Free Account
                                </AnimatedButton>
                            </form>
                        </div>

                        <div className="formrow" id="fineprint">
                            <p>
                                By clicking "Get A Free Account" you agree to the OpenDNS <a href="https://www.opendns.com/consumer-terms/" target="_blank" className="ext-link" data-type="Terms of Service">Terms of Service</a> and <a href="http://www.cisco.com/web/siteassets/legal/privacy_full.html" target="_blank" className="ext-link" data-type="Privacy Policy">Cisco Online Privacy Statement</a>
                            </p>
                            <p>Just want DNS without creating an account? <a href="https://www.opendns.com/setupguide/">Go right ahead!</a></p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default MainForm;



// WEBPACK FOOTER //
// ./src/homefree/js/partials/MainForm.js